import React, {
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import ReleaseNotificacao from '.././../../componentsLocal/Notificacoes/Release';

import { toast } from 'react-toastify';

import { LinearProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {
  LocalGasStation,
  ArrowDownward,
  LocalShipping,
} from '@material-ui/icons';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';

import Barrel from '~/assets/icons/barrel.svg';
import { DESCARGA_NF, SOBRAS_E_FALTAS } from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';
import { store } from '~/store';
import { closeNotification } from '~/store/modules/notification/actions';

import ReleaseNotificacao from '../../../../componentsLocal/Notificacoes/Release';
import CustomizedDialogs from '../../../../componentsLocal/UnidataDialog';
import {
  Header,
  CardPioresRecebimentos,
  CardPerdas,
  IconWithSmallerIcon,
  CardPercCapTq,
  CardTiposAbast,
  CardVazoesNaoAutorizadas,
  CardHorariosPicos,
  CardTurnos,
} from '../components';
import * as S from './styles';

export default function VisaoGeral({ headerIcon }) {
  const dispatch = useDispatch();

  const { profile } = store.getState().user;
  const { opened } = useSelector((state) => state.notification);

  const closeModal = () => {
    dispatch(closeNotification(false));
  };

  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState(null);
  const [labelPesquisa, setLabelPesquisa] = useState();
  const [headerHeight, setHeaderHeight] = useState('50px');
  const [urlAtual, setUrlAtual] = useState(null);
  const headerRef = useRef(null);

  const usarMedia = urlAtual && urlAtual.includes('idposto');

  useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(`${headerRef.current.offsetHeight}px`);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const pesquisar = useCallback(
    ({ periododias, idposto, idproduto, codigonomeposto, nomeproduto }) => {
      if (!periododias) return;

      let url = `dashboardvisaogeral?periododias=${periododias}`;
      if (idposto) url += `&idposto=${idposto}`;
      if (idproduto) url += `&idproduto=${idproduto}`;

      if (codigonomeposto) {
        let label = codigonomeposto;
        if (nomeproduto) label += `(${nomeproduto})`;
        setLabelPesquisa(label);
      } else if (nomeproduto) {
        setLabelPesquisa(nomeproduto);
      } else {
        setLabelPesquisa(t('s.dashboard.visaogeral.mediageral'));
      }

      setLoading(true);
      setUrlAtual(url);
    },
    []
  );

  const handleResponseAPI = useCallback(async () => {
    try {
      const { data } = await api.get(urlAtual);

      setDados(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    if (!urlAtual) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const { data } = await api.get(urlAtual);
        setDados(data);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // Agenda o intervalo de 20 minutos
    const interval = setInterval(fetchData, 20 * 60 * 1000);

    return () => clearInterval(interval);
  }, [urlAtual]);

  return (
    <>
      <S.Wrapper>
        <Header
          onSubmit={pesquisar}
          ref={headerRef}
          icon={headerIcon}
          disabled={loading}
        />
        {loading && <LinearProgress />}
        {dados && (
          <S.CardsWrapper style={{ '--header-height': headerHeight }}>
            <S.Linha1>
              <CardHorariosPicos
                legendaPosto={labelPesquisa}
                data={dados.ocupacaohoras}
                mostrarMedia={usarMedia}
                style={{ gridRow: 'span 2' }}
              />
              <CardTurnos
                title={t('s.dashboard.visaogeral.turnosposto')}
                icon={<LocalGasStation />}
                headers={[
                  t('s.menu.configuracao.posto'),
                  t('s.relatorio.afericao.data'),
                ]}
                data={dados.turnos}
                tooltip={t('s.dashboard.visaogeral.tooltip.turnosposto')}
                disabled={!can(SOBRAS_E_FALTAS)}
                style={{ minHeight: '180px' }}
              />

              <CardPerdas
                title={t('s.dashboard.visaogeral.maioresperdas').replace(
                  '%s',
                  t('s.menu.configuracao.posto')
                )}
                icon={
                  <IconWithSmallerIcon
                    iconeMaior={<LocalGasStation />}
                    iconeMenor={<ArrowDownward />}
                  />
                }
                headers={[
                  t('s.menu.configuracao.posto'),
                  t('s.menu.configuracao.produto'),
                  t('s.geral.perda'),
                ]}
                data={dados.perdaspostos}
                tooltip={t('s.dashboard.visaogeral.tooltip.perdas')
                  .replace('%s', t('s.menu.configuracao.posto').toLowerCase())
                  .replace('%s', t('s.menu.configuracao.posto').toLowerCase())}
                disabled={!can(SOBRAS_E_FALTAS)}
                style={{ minHeight: '180px' }}
              />

              <CardPercCapTq
                titulo={t('s.dashboard.visaogeral.ocupacaotanque').replace(
                  '%s',
                  t('s.menu.configuracao.posto')
                )}
                icone={
                  <IconWithSmallerIcon
                    iconeMaior={<LocalGasStation />}
                    iconeMenor={
                      <img alt="Barrel" src={Barrel} style={{ padding: 1 }} />
                    }
                  />
                }
                headers={[
                  t('s.menu.configuracao.posto'),
                  t('s.menu.configuracao.produto'),
                  t('s.relatorio.geral.percentual'),
                ]}
                data={dados.percentuaistanquesabastecimentospostos}
                tooltip={t(
                  's.dashboard.visaogeral.tooltip.percentualtanque'
                ).replace('%s', t('s.menu.configuracao.posto').toLowerCase())}
                style={{ minHeight: '180px' }}
              />

              <CardTurnos
                title={t('s.dashboard.visaogeral.viagenscomboio')}
                icon={<LocalShipping />}
                headers={[
                  t('s.menu.configuracao.comboio'),
                  t('s.relatorio.afericao.data'),
                ]}
                data={dados.viagens}
                tooltip={t('s.dashboard.visaogeral.tooltip.viagenscomboio')}
                style={{ minHeight: '180px' }}
              />

              <CardPerdas
                title={t('s.dashboard.visaogeral.maioresperdas').replace(
                  '%s',
                  t('s.menu.configuracao.comboio')
                )}
                icon={
                  <IconWithSmallerIcon
                    iconeMaior={<LocalShipping />}
                    iconeMenor={<ArrowDownward />}
                  />
                }
                headers={[
                  t('s.menu.configuracao.comboio'),
                  t('s.menu.configuracao.produto'),
                  t('s.geral.perda'),
                ]}
                data={dados.perdascomboios}
                tooltip={t('s.dashboard.visaogeral.tooltip.perdas')
                  .replace(
                    /%s/g,
                    t('s.menu.configuracao.comboio').toLowerCase()
                  )
                  .replace(
                    '%s',
                    t('s.menu.configuracao.comboio').toLowerCase()
                  )}
                style={{ minHeight: '180px' }}
              />

              <CardPercCapTq
                titulo={t('s.dashboard.visaogeral.ocupacaotanque').replace(
                  '%s',
                  t('s.menu.configuracao.comboio')
                )}
                icone={
                  <IconWithSmallerIcon
                    iconeMaior={<LocalShipping />}
                    iconeMenor={
                      <img alt="Barrel" src={Barrel} style={{ padding: 1 }} />
                    }
                  />
                }
                headers={[
                  t('s.menu.configuracao.comboio'),
                  t('s.menu.configuracao.produto'),
                  t('s.relatorio.geral.percentual'),
                ]}
                data={dados.percentuaistanquesabastecimentoscomboios}
                tooltip={t(
                  's.dashboard.visaogeral.tooltip.percentualtanque'
                ).replace('%s', t('s.menu.configuracao.comboio').toLowerCase())}
                style={{ minHeight: '180px' }}
              />
            </S.Linha1>
            <S.Linha2>
              <CardPioresRecebimentos
                cards={dados.descargascomperdas}
                disabled={!can(DESCARGA_NF)}
              />
              <CardVazoesNaoAutorizadas
                style={{ minHeight: '350px' }}
                data={dados.vazoesnaoautorizadas}
              />

              <CardTiposAbast
                style={{ minHeight: '350px' }}
                data={dados.tiposabastecimentos}
              />
            </S.Linha2>
          </S.CardsWrapper>
        )}
      </S.Wrapper>

      <CustomizedDialogs
        open={process.env.REACT_APP_TAG !== profile.versao && opened}
        handleClose={closeModal}
        title={`Lançada nova versão ${process.env.REACT_APP_TAG}`}
        children={<ReleaseNotificacao />}
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.open('/changesrelease', '_blank');
                closeModal();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                closeModal();
              }}
            >
              Não
            </Button>
          </>
        }
      />
    </>
  );
}

VisaoGeral.propTypes = {
  headerIcon: PropTypes.element,
};

VisaoGeral.defaultProps = {
  headerIcon: null,
};
